export const GET_VENDOR_LOG_LIST_REQUEST = "GET_VENDOR_LOG_LIST_REQUEST"
export const GET_VENDOR_LOG_LIST_SUCCESS = "GET_VENDOR_LOG_LIST_SUCCESS"
export const DELETE_VENDOR_LOG_REQUEST = "DELETE_VENDOR_LOG_REQUEST"
export const DELETE_VENDOR_LOG_SUCCESS = "DELETE_VENDOR_LOG_SUCCESS"
export const CLEAR_VENDOR_LOG_LIST = "CLEAR_VENDOR_LOG_LIST"
